import { action, computed, IObservableValue, observable } from 'mobx';
import { OperationalRatingTypeEnum } from '../enums/operationalRatingType';

class RatingStore {
    @observable operationalRatingType: IObservableValue<OperationalRatingTypeEnum | null>;

    constructor() {
        this.operationalRatingType = observable.box<OperationalRatingTypeEnum | null>(null);
    }

    @computed
    get selectedOperationalRatingType() {
        return this.operationalRatingType.get();
    }

    /**
     * Устанавливаем значение типа оперативного рейтинга
     */
    @action('set operationalRatingType')
    setOperationalRatingType = (operationalRatingType: OperationalRatingTypeEnum | null) => {
        this.operationalRatingType.set(operationalRatingType);
    }
}

const ratingStore = new RatingStore();

export default ratingStore;
export { RatingStore };
